// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1djsX","toggle":"styles_toggle__2NfSu","preview":"styles_preview__MdvR-"};